import { useEffect, useState } from "react";
import { downloadAssessmentApplicantReport } from "../../../service/CreatedAssessmentListAndReview/CreatedAssessmentListAndReview";
import "./AssessmentReport.scss";
import Loader from "../../../components/Loader/Loader";
import { PDFViewer } from "@react-pdf/renderer";
import DownloadIcon from "../../../utils/Images/DownloadIcon";
import AssessmentReport from "./AssessmentReport";
import { useTranslation } from "react-i18next";
interface DownloadReportBtnProps {
  applicantId: any;
  assessmentIdParam: any;
  label?: string;
  downloadingLabel?: string;
  children?: React.ReactNode;
  customIcon?: React.ReactNode;
}
const DownloadReportBtn = ({
  applicantId,
  assessmentIdParam,
  label = "",
  children,
  customIcon = <DownloadIcon />,
}: DownloadReportBtnProps) => {
  const [reportDownloadLoading, setReportDownloadLoading] = useState(true);
  const [showPreview, setShowPreview] = useState(false);
  const [reportData, setReportData] = useState<any>({
    applicantDetails: null,
    applicantSkillExperience: [],
    assessmentSkills: [],
    categoryScore: [],
    skillDIfficultyScore: [],
    skillScore: [],
  });
  const { t } = useTranslation();
  const getReportDataApi = async () => {
    setReportDownloadLoading(true);
    try {
      const res = await downloadAssessmentApplicantReport(
        applicantId,
        assessmentIdParam,
      );
      if (res?.status === 200) {
        const response = await res?.data;
        const codingSummary = { ...response?.codingSummary };
        delete codingSummary?.user_output; //remove user output from coding summary
        delete codingSummary?.code_correctness; //remove code correctness from coding summary
        const newReportData = {
          applicantDetails: response?.ApplicantAssessment,
          applicantSkillExperience:
            response?.assessmentApplicantSkillExperience,
          assessmentSkills: response?.assessmentSkills,
          categoryScore: response?.categoryScore,
          skillDIfficultyScore: response?.skillDIfficultyScore,
          skillScore: response?.skillScore,
          finalRecommendation: response?.finalRecommendation,
          codingSummary: codingSummary,
        };

        setReportData(newReportData);
      }
      setReportDownloadLoading(false);
    } catch (error) {
      console.error("PDF generation failed", error);
      setReportDownloadLoading(false);
    }
  };
  useEffect(() => {
    getReportDataApi();
  }, []);

  return (
    <div>
      {reportDownloadLoading ? (
        <div className="downloadReportSec">
          <span className="downloadReportSecLabel">{t("GENERAL.LOADING")}</span>
          <div className="disableDownloadSec">
            <Loader />
          </div>
        </div>
      ) : (
        <div>
          <div
            className="downloadReportSec"
            onClick={() => setShowPreview(true)}
          >
            {children ? (
              children
            ) : (
              <div className="downloadReportSec">
                <span className="downloadReportSecLabel">{label}</span>
                {customIcon}
              </div>
            )}
          </div>
          {showPreview && (
            <div className="pdfPreviewModal">
              <div className="pdfPreviewContent">
                <div
                  className="closePreviewButton"
                  onClick={() => setShowPreview(false)}
                >
                  ×
                </div>
                <PDFViewer style={{ width: "100%", height: "100%" }}>
                  <AssessmentReport reportData={reportData} />
                </PDFViewer>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default DownloadReportBtn;
